import React from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function InlineBulletList({
    children,
    className,
    Tag = 'ul',
    ...rest }
) {
    const childrenToRender = React.Children.toArray(children)
        .filter(child => !isEmpty(child))
        .map((child, index, filteredChildren) => {
            if (index < filteredChildren.length - 1) {
                return (
                    <React.Fragment key={index}>
                        {child}
                        <span aria-hidden="true" >
                            &bull;
                        </span>
                    </React.Fragment>
                )
            }

            return child;
    });

    return (
        <Tag
            data-component="InlineBulletList"
            className={cx('sarsa-inline-bullet-list', className)}
            {...rest}>
            {childrenToRender}
        </Tag>
    );
}

InlineBulletList.propTypes = {
    /** List items */
    children: PropTypes.node,

    /** Html tag to use for the list container */
    Tag: PropTypes.string,

    /** Additional class added to the outer container */
    className: PropTypes.string
}
